import { Action } from '@/_core/fluxstore/types';
import { NotificationsState } from '../types';
import { useNotificationsStore } from '../useModule';
import { DismissNotificationOfUserCommand } from '@/api/notifications/commands';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerMiddleware, registerReducer } = useNotificationsStore();

export class DismissNotificationOfUser extends Action<NotificationsState> {
    public static ACTION_TYPE = 'DismissNotificationOfUser';
    public constructor(public notificationId: string) {
        super(DismissNotificationOfUser.ACTION_TYPE);
    }
}

const middleware = async (state: NotificationsState, action: DismissNotificationOfUser): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new DismissNotificationOfUserCommand(action.notificationId),
    });
};

const reducer = (state: NotificationsState, action: DismissNotificationOfUser): void => {
    const toDismiss = state.allNotifications.filter((x) => x.id === action.notificationId);

    toDismiss[0].isDismissed = true;
};

//@ts-ignore
registerMiddleware(DismissNotificationOfUser.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DismissNotificationOfUser.ACTION_TYPE, reducer);
